import { useTranslation } from 'next-i18next'

import { useRouter } from 'next/router'

import { Link } from '~/components'
import Collapse from '~/components/Collapse/Collapse'

import { prerequisite } from '~/bootcamp/types/bootcamp.types'
import bootcampAnalytics from '~/analytics/bootcamp/bootcampAnalytics'
import { AppLanguage } from '~/types/locale'

interface Props {
  items: prerequisite[]
  className?: string
  title: string
}

const renderPrerequisite = ({ name, url }: prerequisite): React.ReactElement => {
  if (url) {
    return (
      // Adding locale="en" to default the link to the english page
      <Link className="text-xs sm:text-base" key={name} locale={AppLanguage.EN} to={url}>
        <li>{name}</li>
      </Link>
    )
  }

  return (
    <li className="text-xs sm:text-base" key={name}>
      {name}
    </li>
  )
}

const PrerequisitesCollapse = ({ items = [], className = '', title }: Props): React.ReactElement => {
  const { t } = useTranslation('bootcamp')
  const { query } = useRouter()

  const trackCollapseClick = (isExpanded: boolean): void => {
    const obj = {
      category: query.subtopic as string,
      subject: query.key as string,
      title,
      status: isExpanded ? 'open' : 'close',
    }
    bootcampAnalytics.logClickPrerequisitesDropdown(obj)
  }

  return (
    <Collapse
      arrowDirection="left"
      className={`rounded-b-medium pt-2 -mt-2 ${className}`}
      collapseDirection="bottom"
      isDisabled={!items.length}
      onTitleClick={trackCollapseClick}
      title={t('prerequisites')}
      titleClassName="w-full text-white text-xs sm:text-base font-semibold ml-2 space-x-1"
    >
      <ul className="text-white list-disc ml-4 px-3 pb-0 last:pb-2" data-testid="prerequisites-list">
        {items.map(renderPrerequisite)}
      </ul>
    </Collapse>
  )
}

export default PrerequisitesCollapse
